import {
  Accordion,
  Breakpoints,
  ControlIconType,
  FontSize,
  NextgenDOMPurify,
  useBreakpoint,
  useTranslation,
} from '@nextgen-web-framework/all';
import { FC, KeyboardEvent, MouseEvent, useState } from 'react';
import styles from './FAQsComponent.module.scss';
import type { FAQAccordionType, FAQsComponentPropsTypes, FAQType } from './types/propsTypes';

const FAQAccordion: FC<FAQAccordionType> = ({
  faq,
  index,
  onAccordionToggle,
  isMobile,
}: FAQAccordionType): JSX.Element => {
  const [accordionStatus, setAccordionStatus] = useState(false);
  return (
    <div key={index} className={`${styles['faq-accordion']} ${accordionStatus ? styles['faq-accordion-show'] : ''}}`}>
      <Accordion
        id={`faq-accordion-${index}`}
        title={faq.question}
        iconType={ControlIconType.CHEVRON}
        onToggleCallback={(e: MouseEvent | KeyboardEvent, status: boolean) => {
          if (onAccordionToggle && typeof onAccordionToggle === 'function') {
            onAccordionToggle(e, status, faq, index);
          }
          setTimeout(() => setAccordionStatus(status));
        }}
        className={styles['faq-external-styles']}
        fontSize={isMobile ? FontSize.SMALL : FontSize.LARGE}
      >
        <span dangerouslySetInnerHTML={{ __html: NextgenDOMPurify(faq.answer) }} />
      </Accordion>
    </div>
  );
};

const FAQsComponent: FC<FAQsComponentPropsTypes> = ({
  faqs,
  onAccordionToggle,
}: FAQsComponentPropsTypes): JSX.Element => {
  const t = useTranslation();
  let isMobile = false;
  const viewportType = useBreakpoint();
  if ([Breakpoints.XS, Breakpoints.SM].includes(viewportType as Breakpoints)) {
    isMobile = true;
  }
  return (
    <>
      {faqs?.length > 0 && (
        <div className={styles['faqs-container']}>
          <div className={styles['faqs-header']}>
            <h2 className={styles['faqs-header-first-line']}>{t('product.faqs.heading')}</h2>
          </div>
          {faqs?.map((faq: FAQType, index: number) => (
            <FAQAccordion
              faq={faq}
              index={index}
              key={`faq_${faq.question}`}
              onAccordionToggle={onAccordionToggle}
              isMobile={isMobile}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default FAQsComponent;
export type { FAQsComponentPropsTypes, FAQType };
